import * as Sentry from '@sentry/react';

// Supports string or regexp
const ignoreErrors: string[] = ['Load failed'];

/**
 * Do not use on Astro pages, this is configured already in the Astro config file
 * Only use on Webpack entry points
 */
export function initSentry() {
  if (process.env.PUBLIC_SENTRY_DISABLED === 'true') {
    return;
  }

  Sentry.init({
    dsn: process.env.PUBLIC_SENTRY_DSN,
    environment: process.env.PUBLIC_HR_ENV,
    release: process.env.COMMIT_SHA,
    tracesSampleRate: 0.01, // Sets the sample rate at 1%
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/.*\.hungryroot\.com\/api/,
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    ignoreErrors,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  });
}
